import { colors } from '../../tokens/colors.js'
import { radius } from '../../utils/radius.js'
import { shadows } from '../../utils/shadows.js'
import { Counter } from '../Counter/index.js'
import { Media, MediaProps } from '../Media/index.js'
import { Text } from '../Text/index.js'

type DragPreviewProps = (
  | {
      variant?: 'regular'
    }
  | {
      variant?: 'card'
      src: string
    }
) & {
  value: string
  count?: number
}

function DragPreview(props: DragPreviewProps) {
  if (props.variant === 'card') {
    return (
      <div
        style={{
          position: 'relative',
          display: 'inline-flex',
        }}
      >
        {props.count && (
          <div
            style={{
              position: 'absolute',
              left: 0,
              top: 0,
              transform: 'translate(-50%, -50%)',
            }}
          >
            <Counter color="neutral">{props.count}</Counter>
          </div>
        )}
        <div
          style={{
            // boxShadow: shadows.popoverLarge,
            background: colors.neutralInverted100,
            borderRadius: radius[8],
          }}
        >
          <div
            style={{
              width: 90,
              height: '100%',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'flex-start',
              flexDirection: 'column',
              background: colors.neutral10Adjusted,
              borderRadius: radius[8],
              border: `1px solid ${colors.neutral10}`,
              padding: 8,
              gap: 12,
            }}
          >
            <div
              style={{
                height: 72,
                width: 72,
                border: `1px solid ${colors.neutral20Adjusted}`,
                borderRadius: radius[4],
                overflow: 'hidden',
              }}
            >
              <Media
                src={props.src}
                //   objectFit="cover"
                optimizedImageWidth={72}
              />
            </div>
            <div style={{ width: '100%' }}>
              <Text singleLine color="neutral80" variant="display-medium">
                {props.value}
              </Text>
            </div>
          </div>
        </div>
        {props.count && (
          <div
            style={{
              width: 4,
              position: 'absolute',
              top: 'calc(15%/2)',
              bottom: 'calc(15%/2)',
              right: -4,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              // boxShadow: shadows.popoverLarge,
              background: colors.neutralInverted100,
              borderTopRightRadius: radius[8],
              borderBottomRightRadius: radius[8],
            }}
          >
            <div
              style={{
                height: '100%',
                width: '100%',
                borderTopRightRadius: radius[8],
                borderBottomRightRadius: radius[8],
                background: colors.neutral10Adjusted,
                borderBottom: `1px solid ${colors.neutral10}`,
                borderTop: `1px solid ${colors.neutral10}`,
                borderRight: `1px solid ${colors.neutral10}`,
              }}
            />
          </div>
        )}
      </div>
    )
  }

  return (
    <div
      style={{
        position: 'relative',
        display: 'inline-flex',
      }}
    >
      {props.count && (
        <div
          style={{
            position: 'absolute',
            left: 0,
            top: 0,
            transform: 'translate(-50%, -50%)',
          }}
        >
          <Counter color="neutral">{props.count}</Counter>
        </div>
      )}
      <div
        style={{
          height: 44,
          width: 'fit-content',
          maxWidth: 360,
          // boxShadow: shadows.popoverLarge,
          background: colors.neutralInverted100,
          borderRadius: radius[8],
        }}
      >
        <div
          style={{
            height: '100%',
            width: '100%',
            paddingLeft: 14,
            paddingRight: 14,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            background: colors.neutral10Adjusted,
            borderRadius: radius[8],
            border: `1px solid ${colors.neutral10}`,
          }}
        >
          <Text singleLine color="neutral80" variant="display-medium">
            {props.value}
          </Text>
        </div>
      </div>
      {props.count && (
        <div
          style={{
            height: 4,
            position: 'absolute',
            left: 'calc(25%/2)',
            right: 'calc(25%/2)',
            bottom: -4,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            // boxShadow: shadows.popoverLarge,
            background: colors.neutralInverted100,
            borderBottomLeftRadius: radius[8],
            borderBottomRightRadius: radius[8],
          }}
        >
          <div
            style={{
              height: '100%',
              width: '100%',
              borderBottomLeftRadius: radius[8],
              borderBottomRightRadius: radius[8],
              background: colors.neutral10Adjusted,
              borderBottom: `1px solid ${colors.neutral10}`,
              borderLeft: `1px solid ${colors.neutral10}`,
              borderRight: `1px solid ${colors.neutral10}`,
            }}
          />
        </div>
      )}
    </div>
  )
}

export { DragPreview }
export type { DragPreviewProps }
